import { FC } from 'react';
import { Redirect, Route } from 'react-router';
import { CaregiverHomePage } from '../home/CaregiverHomePage';
import { InsightsPageRouteHandler } from '../insights/InsightsPage';
import { OnboardingPageRouteHandler } from '../onboarding/OnboardingPage';

export const CaregiverRouter: FC = () => (
    <>
        <Route exact path="/caregiver/daily-log" render={() => {
            return <Redirect to={'/calendar/journal/daily-log'} />;
        }} />

        <InsightsPageRouteHandler />
        <OnboardingPageRouteHandler />

        <Route exact path="/caregiver" render={(props) => {
            const careMapId = new URLSearchParams(props.location.search).get('id') || undefined;
            return <>
                <CaregiverHomePage careMapId={careMapId}/>
            </>;
        }} />
    </>
);
